@if (nextScheduledOpkraevning) {
  <p class="no-margin-top orange inline-flex">
    Næste planlagte opkrævning:&#160;
    <strong>kl. {{ nextScheduledOpkraevning | date : 'shortTime' }}</strong>
  </p>
}
@if (isAdmin) {
  <div class="inline-flex">
    <button mat-raised-button color="primary" (click)="onStartAfregningerClick()">Start manuelt</button>
  </div>
}
@if (isAdmin && !isLoading) {
  <div class="inline-flex">
    <button mat-raised-button color="primary" (click)="onRecalculateAllAgreementsClick()">Genberegn pris på alle aftaler</button>
  </div>
}
@if (!isLoading) {
  <div class="flex-wrap flex-wrap--flex-start margin-bottom-x2">
    <div class="flex-wrap__col flex-wrap__col--40">
      <h2>Seneste afregninger</h2>
      @if (recentServiceafregningerLoading$ | async) {
        <div class="flex align-center">
          <div class="loading loading--dark"></div>
        </div>
      }
      <table mat-table [dataSource]="recentServiceafregninger">
        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef>Dato</th>
          <td mat-cell *matCellDef="let afregning">{{ afregning.ajourtid | date : 'short' }}</td>
        </ng-container>
        <ng-container matColumnDef="bilagId">
          <th mat-header-cell *matHeaderCellDef>Bilagsnr.</th>
          <td mat-cell *matCellDef="let afregning">{{ afregning.bilagsnr }}</td>
        </ng-container>
        <ng-container matColumnDef="oKAftaleNr">
          <th mat-header-cell *matHeaderCellDef>Aftalenr.</th>
          <td mat-cell *matCellDef="let afregning">{{ afregning.okKundeAftaleNr }}</td>
        </ng-container>
        <ng-container matColumnDef="ordreNo">
          <th mat-header-cell *matHeaderCellDef>Ordrenr.</th>
          <td mat-cell *matCellDef="let afregning">{{ afregning.serviceordreNo }}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="align-right">Beløb</th>
          <td mat-cell *matCellDef="let afregning" class="align-right">{{ afregning.beloebExclMoms }} kr.</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsRecent"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsRecent" (dblclick)="onRowClick(row)"></tr>
      </table>
      <span style="display: inline-block; width: 40px"></span>
      <h2>Opkrævninger / kreditnotaer, der ikke kan afregnes mod G4 ({{ afregningerWithoutBilagTotal }})</h2>
      @if (afregningerWithoutBilagLoading$ | async) {
        <div class="flex align-center">
          <div class="loading loading--dark"></div>
        </div>
      }
      <table mat-table [dataSource]="afregningerWithoutBilag">
        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef>Dato</th>
          <td mat-cell *matCellDef="let afregning">{{ afregning.ajourtid | date : 'short' }}</td>
        </ng-container>
        <ng-container matColumnDef="bilagId">
          <th mat-header-cell *matHeaderCellDef>Bilagsnr.</th>
          <td mat-cell *matCellDef="let afregning">-</td>
        </ng-container>
        <ng-container matColumnDef="oKAftaleNr">
          <th mat-header-cell *matHeaderCellDef>Aftalenr.</th>
          <td mat-cell *matCellDef="let afregning">{{ afregning.okKundeAftaleNr }}</td>
        </ng-container>
        <ng-container matColumnDef="ordreNo">
          <th mat-header-cell *matHeaderCellDef>Ordrenr.</th>
          <td mat-cell *matCellDef="let afregning">{{ afregning.serviceordreNo }}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="align-right">Beløb</th>
          <td mat-cell *matCellDef="let afregning" class="align-right">{{ afregning.beloebExclMoms }} kr.</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsRecent"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsRecent" (dblclick)="onRowClick(row)"></tr>
      </table>
    </div>
    <div class="flex-wrap__col flex-wrap__col--60">
      <h2>Lægges på kø ved næste opkrævning</h2>
      <mat-tab-group>
        <mat-tab label="Kunde abn-opkrævning {{ waitingCustomerOpkraevningTotal }}">
          @if (waitingCustomerOpkraevningLoading$ | async) {
            <div class="flex align-center">
              <div class="loading loading--dark"></div>
            </div>
          }
          <table mat-table [dataSource]="waitingCustomerOpkraevning">
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Dato</th>
              <td mat-cell *matCellDef="let customerOpkraevning">{{ customerOpkraevning.timestamp | date : 'short' }}</td>
            </ng-container>
            <ng-container matColumnDef="oKAftaleNr">
              <th mat-header-cell *matHeaderCellDef>Aftalenr.</th>
              <td mat-cell *matCellDef="let customerOpkraevning">{{ customerOpkraevning.okKundeAftalenr }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
              <td mat-cell *matCellDef="let customerOpkraevning">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="onStartAfregningClick(ServiceafregningBasisEnum.Serviceaftale, OpkraevningScopeEnum.Customer)"
                  >
                  Start
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsAftaleQueue"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsAftaleQueue"></tr>
          </table>
          @if (waitingCustomerOpkraevningTotal > 10) {
            <h5>Der vises 10 ud af {{ waitingCustomerOpkraevningTotal }}</h5>
          }
        </mat-tab>
        <mat-tab label="Partnerafregning abn: {{ waitingPartnerkrediteringTotal }}">
          @if (waitingPartnerkrediteringLoading$ | async) {
            <div class="flex align-center">
              <div class="loading loading--dark"></div>
            </div>
          }
          <table mat-table [dataSource]="waitingPartnerkreditering">
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Dato</th>
              <td mat-cell *matCellDef="let partnerkreditering">{{ partnerkreditering.timestamp | date : 'short' }}</td>
            </ng-container>
            <ng-container matColumnDef="oKAftaleNr">
              <th mat-header-cell *matHeaderCellDef>Aftalenr.</th>
              <td mat-cell *matCellDef="let partnerkreditering">{{ partnerkreditering.okKundeAftalenr }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
              <td mat-cell *matCellDef="let customerOpkraevning">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="onStartAfregningClick(ServiceafregningBasisEnum.Serviceaftale, OpkraevningScopeEnum.Partner)"
                  >
                  Start
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsAftaleQueue"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsAftaleQueue"></tr>
          </table>
          @if (waitingPartnerkrediteringTotal > 10) {
            <h5>Der vises 10 ud af {{ waitingPartnerkrediteringTotal }}</h5>
          }
        </mat-tab>
        <mat-tab label="Kunde forbrugsafregning: {{ waitingCustomerServiceordreafregningTotal }}">
          @if (waitingCustomerServiceordreafregningLoading$ | async) {
            <div class="flex align-center">
              <div class="loading loading--dark"></div>
            </div>
          }
          <table mat-table [dataSource]="waitingCustomerServiceordreafregning">
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Dato</th>
              <td mat-cell *matCellDef="let customerServiceordreafregning">
                {{ customerServiceordreafregning.timestamp | date : 'short' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="oKAftaleNr">
              <th mat-header-cell *matHeaderCellDef>Aftalenr.</th>
              <td mat-cell *matCellDef="let customerServiceordreafregning">{{ customerServiceordreafregning.okKundeAftalenr }}</td>
            </ng-container>
            <ng-container matColumnDef="serviceordreNo">
              <th mat-header-cell *matHeaderCellDef>Ordrenr.</th>
              <td mat-cell *matCellDef="let customerServiceordreafregning">{{ customerServiceordreafregning.serviceordreNo }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
              <td mat-cell *matCellDef="let customerOpkraevning">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="onStartAfregningClick(ServiceafregningBasisEnum.Serviceordre, OpkraevningScopeEnum.Customer)"
                  >
                  Start
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsAfregningQueue"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsAfregningQueue"></tr>
          </table>
          @if (waitingCustomerServiceordreafregningTotal > 10) {
            <h5>Der vises 10 ud af {{ waitingCustomerServiceordreafregningTotal }}</h5>
          }
        </mat-tab>
        <mat-tab label="Partnerafregning forbrug: {{ waitingPartnerServiceordreafregningerTotal }}">
          @if (waitingPartnerServiceordreafregningerLoading$ | async) {
            <div class="flex align-center">
              <div class="loading loading--dark"></div>
            </div>
          }
          <table mat-table [dataSource]="waitingPartnerServiceordreafregninger">
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Dato</th>
              <td mat-cell *matCellDef="let partnerServiceordreafregning">
                {{ partnerServiceordreafregning.timestamp | date : 'short' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="oKAftaleNr">
              <th mat-header-cell *matHeaderCellDef>Aftalenr.</th>
              <td mat-cell *matCellDef="let partnerServiceordreafregning">{{ partnerServiceordreafregning.okKundeAftalenr }}</td>
            </ng-container>
            <ng-container matColumnDef="serviceordreNo">
              <th mat-header-cell *matHeaderCellDef>Ordrenr.</th>
              <td mat-cell *matCellDef="let customerServiceordreafregning">{{ customerServiceordreafregning.serviceordreNo }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
              <td mat-cell *matCellDef="let customerOpkraevning">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="onStartAfregningClick(ServiceafregningBasisEnum.Serviceordre, OpkraevningScopeEnum.Partner)"
                  >
                  Start
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsAfregningQueue"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsAfregningQueue"></tr>
          </table>
          @if (waitingPartnerServiceordreafregningerTotal > 10) {
            <h5>Der vises 10 ud af {{ waitingPartnerServiceordreafregningerTotal }}</h5>
          }
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}
@if (isLoading) {
  <div mat-dialog-content class="excel__download flex-wrap flex-wrap--center">
    <div mat-dialog-content>
      <p class="orange med-text align-center">
        <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
        <br />
        <span>Opdaterer priser - Dette kan tage flere minutter. Vent venligst</span>
      </p>
      <div class="flex margin--top-l margin--bottom-l align-center">
        <div class="loading loading--dark"></div>
      </div>
    </div>
  </div>
}
